import { fetcher } from "helpers/fetcher";

import { TGetStaffRetirementPaymentRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeRetirementPayment = async (userId: string) => {
  return await fetcher<TGetStaffRetirementPaymentRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_RETIREMENT_PAYMENT,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.USER.GET_EMPLOYEE_RETIREMENT_PAYMENT.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeRetirementPayment = async (userId: string) => {
  return (await getEmployeeRetirementPayment(userId)).data;
};

queryGetEmployeeRetirementPayment._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_RETIREMENT_PAYMENT.url,
  userId,
];
